<template>
  <v-container fluid>
    <V-row>
      <v-col md="12">
        <SettingItem
          @loadData="loadData"
          collection="attribute_value"
          :items="attribute_value"
          :itemHeader="attributeItemHeader"
        />
      </v-col>
    </V-row>
  </v-container>
</template>

<script>
import SettingItem from "./SettingItem/index";
import ApiService from "@/services/api.service";

export default {
  components: {
    SettingItem,
  },
  data() {
    return {
      attribute_value: [],
      attributeItemHeader: [
        { text: "id", value: "id" },
        { text: "Title", value: "english_title" },
        { text: "Attribute", value: "attribute_id.english_title" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {},
  methods: {
    async loadData() {
      try {
        this.loading = true;
        this.fetchData();
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchData() {
      try {
        const data = await ApiService.get(
          "items/attribute_value?fields=id,arabic_title,english_title,arabic_description,english_description,background_color,sequence,attribute_id.english_title,attribute_id.id,image.id"
        );
        this.attribute_value = data.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.fetchData(undefined);
  },
};
</script>

<style></style>
